export default [
  {
    id: 'basic',
    features: {
      included: [
        'basicOverlays',
        'discreteWatermark',
        'emailSupport',
      ],
      excluded: [
        'premiumOverlays',
        'animatedPacks',
        'aiFunctions',
      ],
    },
  },
  {
    id: 'pro',
    popular: true,
    features: {
      included: [
        'unlimitedBasicOverlays',
        'premiumOverlaysLimited',
        'animatedPacks',
        'prioritySupport',
        'noWatermark',
      ],
      excluded: [
        'advancedAI',
      ],
    },
  },
  {
    id: 'premium',
    features: {
      included: [
        'unlimitedBasicOverlays',
        'unlimitedPremiumOverlays',
        'animatedPacks',
        'aiScenes',
        'aiChatQuestions',
        'vipSupport',
        'noWatermark',
      ],
      excluded: [],
    },
  },
];